import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { EPISODE_QUALITY_ASSURANCE_REFERENCE_DATA_URL } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getQualityAssuranceReferenceData = createAsyncThunk(
  'stop/getQualityAssuranceReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(EPISODE_QUALITY_ASSURANCE_REFERENCE_DATA_URL, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const qualityAssuranceReferenceSlice = createSlice({
  name: 'stop/qualityAssuranceReference',
  initialState: null,
  reducers: {
    resetQualityAssuranceReference: () => null,
  },
  extraReducers: {
    [getQualityAssuranceReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetQualityAssuranceReference } = qualityAssuranceReferenceSlice.actions;

export default qualityAssuranceReferenceSlice.reducer;
